<h2 data-testid="SUBSYS5_DIARYTABLE_TITLE_TXT" class="text-uppercase mb-0">
	{{ labels().DIARY_TABLE_COMPONENT_TITLE }}
</h2>

<div class="mt-5">
	<tsp-history-filters [isDiary]="true" [isReadonly]="isReadonly()" [filters]="filters()"
		(filtersChange)="updateList($event)" />
</div>

@if (diaries().length) {

<div class="mt-4">
	<tsp-history-table [isDiary]="true" [isReadonly]="isReadonly()" [items]="diaries()" [sortOrder]="sortOrder()"
		(sortOrderChange)="sort($event)" />
</div>

<div class="mt-4">
	<tsp-pagination [collectionSize]="collectionSize()" [(page)]="pageNumber" [(pageSize)]="pageSize"
		(pageChange)="updatePageNumber()" (pageSizeChange)="updatePageSize()" />
</div>
} @else {
<div data-testid="SUBSYS5_DIARYTABLE_EMPTY_TXT" class="mt-4">
	<h3>{{ labels().DIARY_TABLE_COMPONENT_TABLE_EMPTY }}</h3>
</div>
}